/**
 * Vehicle reminder event values
 */
export enum VehicleReminderEventEnum {
	ROAD_TAX = 'road_tax',
	INSURANCE = 'insurance',
	MAINTENANCE = 'maintenance',
	OTHER = 'other',
}
